import CryptoJS from "crypto-js";

/* ==================== Env ==================== */

// Secret key untuk encryptStorage
const STORAGE_KEY = import.meta.env.VITE_STORAGE as string;

// Base URL API
export const URL_API = import.meta.env.VITE_URL_API as string;

/* ==================== Utils ==================== */

/** Cek apakah variable kosong (undefined, null, atau string kosong) */
export const isEmpty = (variable: unknown): boolean =>
  [undefined, null, ""].includes(variable as any);

/* ==================== Crypto ==================== */

/** Encrypt string dengan AES + encodeURIComponent */
export function encryptData(value: string): string {
  const encrypted = CryptoJS.AES.encrypt(value, STORAGE_KEY).toString();
  return encodeURIComponent(encrypted);
}

/** Decrypt string yang sudah di-encryptData */
export function decryptData(value: string): string | null {
  try {
    const decodedValue = decodeURIComponent(value);
    const decrypted = CryptoJS.AES.decrypt(
      decodedValue,
      STORAGE_KEY
    ).toString(CryptoJS.enc.Utf8);

    return decrypted || null;
  } catch (err) {
    console.error("Failed to decrypt data:", err);
    return null;
  }
}

/* ==================== Error Helper ==================== */

type FormError =
  | string
  | Array<string | { value?: string }>
  | Record<string, unknown>
  | null
  | undefined;

/** Ambil pesan error pertama dari struktur FormError */
export function getFirstErrorMessage(err: FormError): string | null {
  if (!err) return null;

  // case string
  if (typeof err === "string") return err;

  // case array
  if (Array.isArray(err)) {
    const first = err[0];
    if (!first) return null;
    if (typeof first === "string") return first;
    return first?.value ?? null;
  }

  // case object (tidak diketahui strukturnya)
  return null;
}

/* ==================== Image Crop ==================== */

export interface PixelCrop {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface CropSize {
  width: number;
  height: number;
}

export async function getCroppedImg(
  imageSrc: string,
  pixelCrop: PixelCrop,
  size?: CropSize
): Promise<string> {
  const image = new Image();
  image.src = imageSrc;

  await new Promise<void>((resolve) => {
    image.onload = () => resolve();
  });

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Failed to get canvas context");
  }

  // gunakan size jika ada, fallback ke ukuran crop
  canvas.width = size?.width ?? pixelCrop.width;
  canvas.height = size?.height ?? pixelCrop.height;

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return canvas.toDataURL("image/jpeg");
}

export function redirectToSso() {
  const urlClient = import.meta.env.VITE_URL_SSO as string;
  const baseUrl = window.location.origin;
  const redirectUrl = `${urlClient}/login?oauthId=${encryptData(baseUrl)}`;
  window.location.href = redirectUrl;
}
